const PER_PAGE = 9;
let page = 0;

export const codeResources = () => {
  let activeTab = $(
    '.code-resources__nav .wp-block-button__link:first'
  )[0]?.getAttribute('data-category');

  $('.code-resources__nav .wp-block-button__link').on('click', function () {
    const cat = this.getAttribute('data-category');
    $(this).parent().addClass('is-active').siblings().removeClass('is-active');

    page = 0;
    activeTab = cat;

    $('.code-resources-tabs__tab').addClass('hidden');
    $(`#tab-${cat}`).removeClass('hidden');

    togglePaginationVisibility();
  });

  const togglePaginationVisibility = () => {
    const hasMorePosts =
      $(`#tab-${activeTab} .wp-block-post.hidden:not(.filtered)`).length > 0;

    $(`#tab-${activeTab} .posts-pagination`).toggleClass(
      'hidden',
      !hasMorePosts
    );
  };

  // on filter select, hide posts
  $('.code-resources-tabs .select').on('change', function () {
    const subject = $(this).val();

    page = 0;

    const $items = $(`#tab-${activeTab} .wp-block-post`);

    if (subject === 'all') {
      $items.removeClass('filtered');
    } else {
      // add filtered class to hide items
      $items.each((_, el) => {
        $(el).toggleClass(
          'filtered',
          el.getAttribute('data-subject') !== subject
        );
      });
    }

    // paginate unfiltered posts
    const $unfilteredItems = $(
      `#tab-${activeTab} .wp-block-post:not(.filtered)`
    );
    $unfilteredItems.slice(0, PER_PAGE).removeClass('hidden');
    $unfilteredItems.slice(PER_PAGE).addClass('hidden');

    togglePaginationVisibility();
  });

  // on view more click, show next posts up to the per page limit
  $('.code-resources-tabs .posts-pagination > .button').on(
    'click',
    function () {
      $(`#tab-${activeTab} .wp-block-post.hidden:not(.filtered)`)
        .slice(0, PER_PAGE)
        .removeClass('hidden');

      togglePaginationVisibility();
      page++;
    }
  );
};

export const codeTools = () => {
  // filter
  $('.code-resources-educational select').on('change', function () {
    const category = this.value;

    $('.code-resources-educational .wp-block-post:not(.cta-card)').each(
      (_, item) => {
        const categories = item.getAttribute('data-category')?.split(',') || [];
        const isVisible = categories.includes(category);

        $(item).toggleClass('filtered', !isVisible);
      }
    );
  });
};
